import { postalRegexMap } from "./postal_code_regex";

export const validatePostalCode = (value: string, country_code?:string): boolean => {
    let result = false;
    // If country code is provided, use the regex for that country
    if (country_code) {
        const regex = postalRegexMap[country_code];
        if (regex) {
        return regex.test(value);
        }
    } else {
        // Otherwise, check against all regexes
        Object.values(postalRegexMap).forEach((regex) => {
        if (regex.test(value)) {
            // If any regex matches, return true
            result = true;
        }
        })
    }
    // If no regex matches, return false
    return result;
}

export const validateEmail = (value: string): boolean => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(value.toLowerCase())
}

export const validatePhone = (value: string): boolean => {
    const re = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
    return re.test(value)
}

export const validateUrl = (value: string): boolean => {
    const re = /^(https:\/\/)([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/
    return re.test(value)
}

export const validateRoutingNumber = (value: string): boolean => {
    // Check the length, it should be nine digits.
    if (value.length !== 9)
        return false;

    // Strip out any non-numeric characters.
    const strippedValue = value.replace(/\D/g, "");

    // Check the length again, it should be nine digits.
    if (strippedValue.length !== 9)
        return false;

    // Run value through the checksum algorithm.
    let checksumNumber = 0;
    for (let i = 0; i < strippedValue.length; i += 3) {
        checksumNumber += (parseInt(strippedValue.charAt(i), 10) * 3) +
            (parseInt(strippedValue.charAt(i + 1), 10) * 7) +
            (parseInt(strippedValue.charAt(i + 2), 10));
    }

    // If the resulting sum is an even multiple of ten (but not zero),
    // the aba routing number is good.
    return checksumNumber !== 0 && checksumNumber % 10 === 0;
}

export const validatePastDate = (value: string): boolean => {
    // Check that date is not in the future
    const date = new Date(value);
    const today = new Date();
    // Set time to 00:00:00
    date.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return date < today;
}

export const validateFutureDate = (value: string): boolean => {
    // Check that date is not in the past
    const date = new Date(value);
    const today = new Date();
    // Set time to 00:00:00
    date.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return date > today;
}

export const validPastDateWithinRange = (value: string, years: number): boolean => {
    // Check that date is not in the future
    const date = new Date(value);
    const today = new Date();
    // Set time to 00:00:00
    date.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    const year = date.getFullYear();
    const todayYear = today.getFullYear();
    return date < today && year >= todayYear - years;
}
